import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DialogsComponent} from './containers/dialogs/dialogs.component';
import {ErrorMarginsComponent} from './containers/error-margins/error-margins.component';
import {CountriesComponent} from './containers/countries/countries.component';
import {WeeeSystemComponent} from './containers/weee-system/weee-system.component';
import {UsersComponent} from './containers/users/users.component';
import {TemplatesComponent} from './containers/templates/templates.component';
import {ChartLabelsComponent} from './containers/chart-labels/chart-labels.component';
import {AdminGuard} from './guards/admin.guard';

const routes: Routes = [
  {
    path: 'admin', canActivate: [AdminGuard],
    children: [
      {path: 'users', component: UsersComponent},
      {path: 'countries', children: [
          {path: 'list', component: CountriesComponent},
          {path: 'upload', component: CountriesComponent},
        ]
      },
      {path: 'countries/list', component: CountriesComponent},
      {path: 'weeesystems', component: WeeeSystemComponent},
      {path: 'templates', component: TemplatesComponent},
      {path: 'info-boxes', component: DialogsComponent},
      {path: 'chart-labels', component: ChartLabelsComponent},
      {path: 'error-margins', component: ErrorMarginsComponent}
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
